import { useVisitStore } from "@/store/visit";
import { useUserStore } from "@/store/user";

const { VITE_CLATITY_ID } = import.meta.env;
let clarityInited = false;

export const initClarity = () => {
  if (clarityInited) {
    return;
  }

  if (VITE_CLATITY_ID) {
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };

      t = l.createElement(r);
      t.defer = 1;
      t.src = `https://www.clarity.ms/tag/${i}`;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", VITE_CLATITY_ID);

    const profile = useUserStore().getProfile;
    const visit = useVisitStore().getVisit || {};

    const identifyId = profile?.id || "000".visit?.id || "";
    window.clarity("identify", identifyId.toString());
    window.clarity("set", "campaign", visit.campaign || "");
    window.clarity("set", "country", visit.country);
    window.clarity("set", "device", parseInt(visit.is_mobile) ? "mobile" : "desktop");
    window.clarity("set", "browser", visit.browser);
    window.clarity("consentv2", {
      ad_Storage: "denied",
      analytics_Storage: "granted",
    });

    const features = profile?.features || {};
    Object.keys(features).forEach((key) => {
      const feature = features[key];
      window.clarity("set", key, feature?.version || "1");
    });

    clarityInited = true;
  }
};
